var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M7.25 8.75V14h1.5V8.75H14v-1.5H8.75V2h-1.5v5.25H2v1.5z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }